// Define the structure for our custom Handlebars blocks
interface HandlebarsBlock {
  id: string;
  label: string;
  template?: string;
  category: string;
  defaultData?: Record<string, any>;
  content?: Record<string, any>;
}

export const HEADER_TEMPLATE = `
<mj-section>
  <mj-raw>
    <table style="width:100%;border-collapse:collapse;margin-bottom:16px;">
      <tr>
        <td style="vertical-align:middle;padding-right:16px;">
          <table style="border-collapse:collapse;">
            <tr>
              <td style="text-align:center;vertical-align:middle;">
                <div>
                  <div class="avatar-photo"
                    style="display:flex;justify-content:center;align-items:center;background-color:#252D44;color:white;height:56px;width:56px;border-radius:50%;font-weight:700;font-size:20px;line-height:24px;">
                    <table style="width:100%;height:100%;">
                      <tr>
                        <td style="text-align:center;vertical-align:middle;font-family:Helvetica, sans-serif;">{{agentAvatarPlaceholder}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
              <td style="padding-left:16px;vertical-align:middle;">
                <p style="font-weight:700;font-size:20px;line-height:24px;margin:0;margin-bottom:8px;font-family:Helvetica, sans-serif;">{{agentFullName}}</p>
                <p style="font-weight:400;font-size:16px;line-height:20px;color:#676767;margin:0;text-align:start;font-family:Helvetica, sans-serif;">
                  Agent</p>
              </td>
            </tr>
          </table>
        </td>
        <td style="text-align:right;vertical-align:middle;"><svg width="185" height="93" viewBox="0 0 185 93" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M50.22 7C50.22 7.62368 50.097 8.24125 49.8579 8.81745C49.6189 9.39365 49.2685 9.9172 48.8268 10.3582C48.3852 10.7992 47.8608 11.149 47.2837 11.3877C46.7066 11.6264 46.0881 11.7492 45.4635 11.7492C44.8389 11.7492 44.2204 11.6264 43.6433 11.3877C43.0662 11.149 42.5418 10.7992 42.1002 10.3582C41.6585 9.9172 41.3081 9.39365 41.0691 8.81745C40.8301 8.24125 40.707 7.62368 40.707 7L50.22 7Z" fill="#FB913A"></path><path d="M118.472 75.4309C118.472 76.0545 118.349 76.6721 118.11 77.2483C117.871 77.8245 117.52 78.3481 117.079 78.7891C116.637 79.2301 116.113 79.5799 115.536 79.8186C114.959 80.0572 114.34 80.1801 113.715 80.1801C113.091 80.1801 112.472 80.0572 111.895 79.8186C111.318 79.5799 110.794 79.2301 110.352 78.7891C109.91 78.3481 109.56 77.8245 109.321 77.2483C109.082 76.6721 108.959 76.0545 108.959 75.4309L113.715 75.4309H118.472Z" fill="#FB913A"></path><path d="M48.1264 75.3398C48.1264 76.1887 47.959 77.0293 47.6336 77.8136C47.3083 78.5979 46.8314 79.3105 46.2302 79.9107C45.629 80.511 44.9153 80.9872 44.1299 81.312C43.3444 81.6369 42.5025 81.8041 41.6523 81.8041L41.6523 75.3398H48.1264Z" fill="#FF576D"></path><path d="M147.42 39.6328C148.021 40.2305 148.498 40.9401 148.823 41.721C149.148 42.5019 149.316 43.3389 149.316 44.1842C149.316 45.0294 149.148 45.8664 148.823 46.6473C148.498 47.4282 148.021 48.1378 147.42 48.7355L142.842 44.1842L147.42 39.6328Z" fill="#4673D1"></path><path d="M172.283 78.1842C172.72 77.7479 173.091 77.2522 173.386 76.7128C173.682 77.2522 174.053 77.7479 174.49 78.1842C175.091 78.7844 175.805 79.2606 176.59 79.5854C177.376 79.9103 178.218 80.0775 179.068 80.0775V73.6133H167.705L167.705 80.0775C168.555 80.0775 169.397 79.9103 170.183 79.5854C170.968 79.2606 171.682 78.7844 172.283 78.1842Z" fill="#FF576D"></path><path d="M12 39.6637L16.6904 34.9805L21.3808 39.6637L16.6904 44.347L12 39.6637Z" fill="#4673D1"></path><path d="M109 17.654L113.69 12.9707L118.381 17.654L113.69 22.3372L109 17.654Z" fill="#FF576D"></path><path d="M167.08 11.9059L171.77 7.22266L176.461 11.9059L171.77 16.5892L167.08 11.9059Z" fill="#51BFE1"></path><path d="M81.365 38.959L85.7251 45.2913H77.0049L81.365 38.959Z" fill="#FF576D"></path></svg></td>
      </tr>
    </table>
  </mj-raw>
</mj-section>
`;

export const FOOTER_TEMPLATE = `
<mj-section>
  <mj-raw>
    <div class="footer" style="text-align:start;font-weight:400;font-size:18px;line-height:24px;">
      <p style="margin:0;margin-bottom:8px;font-family:Helvetica, sans-serif;">Sincerely,</p>
      <div class="footer-info">
        <p style="margin:0;font-family:Helvetica, sans-serif;">{{agentFullName}}</p>
        <p style="margin:0;font-family:Helvetica, sans-serif;">{{agentPhone}}</p>
        <p style="margin:0;text-decoration:none;font-family:Helvetica, sans-serif;">{{agentEmail}}</p>
      </div>
      <div class="rights" style="color:#676767;font-weight:400;font-size:14px;line-height:20px;font-family:Helvetica, sans-serif;">© {{currentYear}} Mosaik, Inc.
        All rights reserved</div>
    </div>
  </mj-raw>
</mj-section>
`;

export const STARTER_TEMPLATE = `
<mjml>
  <mj-head>
    <mj-raw>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&amp;display=swap"
        rel="stylesheet" />
      <link
        href="https://fonts.googleapis.com/css2?family=Cookie&amp;family=Dancing+Script&amp;family=Just+Me+Again+Down+Here&amp;family=Kristi&amp;family=La+Belle+Aurore&amp;family=Pinyon+Script&amp;family=Reenie+Beanie&amp;display=swap"
        rel="stylesheet" />
    </mj-raw>
  </mj-head>
  <mj-body>
    <!-- Header -->
    ${HEADER_TEMPLATE}

    <!-- Editable Content -->
    <mj-section>
      <mj-raw>
        <div class="email-template" style="color:#262626;text-align:left;">
          <p style="margin:0;margin-bottom:16px;font-weight:400;font-size:18px;line-height:24px;text-align:start;font-family:Helvetica, sans-serif;">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p style="margin:0;margin-bottom:16px;font-weight:400;font-size:18px;line-height:24px;text-align:start;font-family:Helvetica, sans-serif;">
            Curabitur non urna at risus volutpat posuere.</p>
          <p style="margin:0;margin-bottom:16px;font-weight:400;font-size:18px;line-height:24px;font-family:Helvetica, sans-serif;">
            Donec a dui velit. Mauris convallis erat ut eros cursus, vitae euismod nisi tincidunt.</p>
          <p style="margin:0;margin-bottom:16px;font-weight:400;font-size:18px;line-height:24px;font-family:Helvetica, sans-serif;">
            Etiam ut ullamcorper nisi, in dignissim felis.</p>
          <p style="margin:0;margin-bottom:16px;font-weight:400;font-size:18px;line-height:24px;font-family:Helvetica, sans-serif;">
            Sed condimentum turpis urna, et interdum neque tristique nec.</p>
        </div>
      </mj-raw>
    </mj-section>

    <!--  Footer -->
    ${FOOTER_TEMPLATE}
  </mj-body>
</mjml>`;

export const initialCustomData = {
  agentFirstName: '',
  agentLastName: '',
  agentPhone: '',
  agentEmail: '',
  agentPhotoUrl: undefined,
  agentFullName: '',
  uuid: '',
  clientFirstName: '',
  clientLastName: '',
  clientFullName: '',
  clientPropertyAddress: '',
  agentAvatarPlaceholder: '',
  currentYear: '', //new Date().getFullYear().toString(),
  feBaseURL: '',
  seeTheListURL: '', // `${frontendUrl}/see-the-list/${uuid}`,
  detailAnalysisURL: '', //`${frontendUrl}/kit-cta/${uuid}`,
  quotesURL: '', //`${frontendUrl}/quotes/${uuid}`,
  inTouchURL: '', //`${frontendUrl}/kit-cta/${uuid}`,
  vaultURL: '', //`${frontendUrl}/vault?source=kits&uuid=${uuid}`,
  servicesURL: '', //`${frontendUrl}/services?source=kits&uuid=${uuid}`,
  ctaURL: '', //`${frontendUrl}/kit-cta/${uuid}`,
};

// Define custom Handlebars blocks
export const customHandlebarsBlocks: HandlebarsBlock[] = [
  {
    id: 'clientName',
    label: 'Client Name',
    template: '<span class="client-name">{{clientName}}</span>',
    category: 'Contact Information',
    defaultData: {},
  },
  {
    id: 'agentName',
    label: 'Agent Name',
    template: '<div class="agent-name">{{agentName}}</div>',
    category: 'Contact Information',
    defaultData: {},
  },
  {
    id: 'signature',
    label: 'Signature',
    template: `
        <div class="signature">
          <p>Best regards,</p>
          <p>{{agentName}}</p>
          <p>{{agentTitle}}</p>
          <p>{{agentPhone}}</p>
          <p>{{agentEmail}}</p>
        </div>
      `,
    category: 'Contact Information',
    defaultData: {
      agentName: 'John Doe',
      agentTitle: 'Real Estate Agent',
      agentPhone: '(555) 555-5555',
      agentEmail: 'john.doe@example.com',
    },
  },
  {
    id: 'header',
    label: 'Custom Header',
    template: HEADER_TEMPLATE,
    category: 'Layout',
    defaultData: {},
  },
  {
    id: 'footer',
    label: 'Custom Footer',
    template: FOOTER_TEMPLATE,
    category: 'Layout',
    defaultData: {},
  },
  {
    id: 'list_component',
    label: 'List Component',
    template: `
        <div style="display:flex;background-color:#f4f6fb;border-radius:8px;padding:16px;margin-bottom:8px;font-family:Helvetica, sans-serif;">
          <ul style="font-weight:700; font-size:18px; line-height:24px; list-style:none; margin:0; padding:0;">
            <li>1. List Item</li>
            <li>2. List Item</li>
            <li>3. List Item</li>
            <li>4. List Item</li>
          </ul>
        </div>
      `,
    category: 'Layout',
    defaultData: {},
    content: {
      type: 'handlebars',
      tagName: 'mj-raw',
      components: [],
    },
  },
  {
    id: 'cta_see_list',
    label: 'See the list - {{seeTheListURL}}',
    template: `
        <a href="{{seeTheListURL}}" style="display: inline-block; text-align: center; background-color: #262d44; width: 100%; border-radius: 12px; font-size: 18px; font-weight: 700; height: 40px; line-height: 40px; color: white; font-family: Helvetica, sans-serif; text-decoration: none;">See the List.</a>
       `,
    category: 'Call To Action',
    defaultData: {},
    content: {
      type: 'handlebars',
      tagName: 'mj-raw',
      components: [],
    },
  },
  {
    id: 'cta_request_analysis',
    label: 'Request detailed analysis - {{detailAnalysisURL}}',
    template: `
        <a href="{{detailAnalysisURL}}" style="display: inline-block; text-align: center; background-color: #262d44; width: 100%; border-radius: 12px; font-size: 18px; font-weight: 700; height: 40px; line-height: 40px; color: white; font-family: Helvetica, sans-serif; text-decoration: none;"> Request detailed analysis.</a>
      `,
    category: 'Call To Action',
    defaultData: {},
    content: {
      type: 'handlebars',
      tagName: 'mj-raw',
      components: [],
    },
  },
  {
    id: 'cta_get_quotes',
    label: 'Get some quotes - {{quotesURL}}',
    template: `
        <a href="{{quotesURL}}" style="display: inline-block; text-align: center; background-color: #262d44; width: 100%; border-radius: 12px; font-size: 18px; font-weight: 700; height: 40px; line-height: 40px; color: white; font-family: Helvetica, sans-serif; text-decoration: none;"> Get some quotes.</a>
      `,
    category: 'Call To Action',
    defaultData: {},
    content: {
      type: 'handlebars',
      tagName: 'mj-raw',
      components: [],
    },
  },
  {
    id: 'cta_get_in_touch',
    label: 'Get in touch - {{inTouchURL}}',
    template: `
        <a href="{{inTouchURL}}" style="display: inline-block; text-align: center; background-color: #262d44; width: 100%; border-radius: 12px; font-size: 18px; font-weight: 700; height: 40px; line-height: 40px; color: white; font-family: Helvetica, sans-serif; text-decoration: none;"> Get in touch.</a>
      `,
    category: 'Call To Action',
    defaultData: {},
    content: {
      type: 'handlebars',
      tagName: 'mj-raw',
      components: [],
    },
  },
];
